module.exports = __webpack_public_path__ + "static/img/nav8.646b296f.png";